
import { IonButtons, IonButton } from '@ionic/vue';
import { defineComponent, onMounted, onUnmounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const RESALTADO_INTERVAL_MS = 15000;
const RESALTADO_DURACION_MS = 900;

export default defineComponent({
  name: 'GalidanciaHomeLogo',
  components: { IonButtons, IonButton },
  setup() {
    const router = useRouter();
    const resaltando = ref(false);
    let intervalId: ReturnType<typeof setInterval> | null = null;
    let timeoutId: ReturnType<typeof setTimeout> | null = null;

    const dispararResaltado = () => {
      resaltando.value = false;
      requestAnimationFrame(() => {
        resaltando.value = true;
      });
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        resaltando.value = false;
      }, RESALTADO_DURACION_MS);
    };

    onMounted(() => {
      intervalId = setInterval(dispararResaltado, RESALTADO_INTERVAL_MS);
    });

    onUnmounted(() => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    });

    const goInicio = () => {
      const path = router.currentRoute.value.path || '';
      if (path === '/tabs/inicio' || path === '/tabs/inicio/') return;
      router.push('/tabs/inicio');
    };

    return { goInicio, resaltando };
  },
});
